<template>
   <div class="container-wrapper" v-loading="loading">
      <div class="breadcrumb-wrapper">
         <span>个性化组件 / {{ title }}</span>
         <el-button class="back" type="primary" @click="$router.go(-1)">返回</el-button>
      </div>

      <div class="content-wrapper">
         <div style="margin-bottom: 20px">
            <span style="margin-right: 45px; color: #48576a;">类型</span>
            <el-select :disabled="!edit" v-model="formData.businessType">
               <el-option v-for="item in businessList" :key="item.value" :label="item.label"
                  :value="item.value"></el-option>
            </el-select>
         </div>
         <BottomButton v-if="formData.businessType === 1" ref="BottomButtonRef" :edit="edit" :form.sync="formData" />
         <HeadFrame v-if="formData.businessType === 2" ref="HeadFrameRef" :edit="edit" :form.sync="formData" />
         <Sticker v-if="formData.businessType === 3" ref="StickerRef" :edit="edit" :form.sync="formData" />
         <PosterSticker v-if="formData.businessType === 4" ref="PosterStickerRef" :edit="edit" :form.sync="formData" />
         <RunningSkin v-if="formData.businessType === 5" ref="RunningSkinRef" :edit="edit" :form.sync="formData" />
         <EmojiPack v-if="formData.businessType === 6" ref="EmojiPackRef" :edit="edit" :form.sync="formData" />
      </div>

      <div class="margin-20">
         <el-button v-if="edit" @click="handleSave(null)">保存</el-button>
         <el-button v-if="edit" type="primary" @click="handleSave(true)">保存并发布</el-button>
      </div>
   </div>
</template>

<script>
import HeadFrame from "./Components/HeadFrame.vue";
import Sticker from "./Components/Sticker.vue";
import PosterSticker from "./Components/PosterSticker.vue";
import BottomButton from "./Components/BottomButton.vue";
import RunningSkin from "./Components/RunningSkin.vue";
import EmojiPack from "./Components/EmojiPack.vue";

export default {
   components: {
      HeadFrame,
      Sticker,
      PosterSticker,
      BottomButton,
      RunningSkin,
      EmojiPack,
   },

   data() {
      return {
         loading: false,
         dialogVisible: false,
         formData: {
            useType: 0,
            businessType: 1,
         },
         id: "",
         edit: "",
         businessList: [
            { label: "主题", value: 1 },
            { label: "头像挂件", value: 2 },
            { label: "动态卡片", value: 3 },
            { label: "海报贴纸", value: 4 },
            { label: "跑步皮肤", value: 5 },
            { label: "表情贴纸", value: 6 },
         ],
      }
   },

   computed: {
      title() {
         const find = this.businessList.find(
            (item) => item.value === this.formData.businessType
         );
         return find.label;
      },
   },

   async created() {
      this.loading = true;
      const query = this.$route.query;
      if (query.id) {
         this.id = query.id; //根据id去查询一下详情
         const res = await this.$http({
            method: "get",
            url: this.$util.domain + "/adminapi/v1/personalizedComponents/detail",
            params: {
               id: this.id,
            },
         })
         if (res.data.error === 10000) {
            let item = res.data.data;
            if (item.businessType === 6) {
               if (item.content && item.content !== '') {
                  item.emojiList = JSON.parse(item.content)
               } else {
                  item.emojiList = []
               }
            }
            this.formData = item;
         } else {
            this.$message.error(res.data.message || "请求错误");
         }
      }
      this.loading = false;
      // 1表示可以编辑 2表示不可编辑
      this.edit = query.edit === "1";
   },

   methods: {
      handleSave(release) {
         const arr = [
            "BottomButtonRef",
            "HeadFrameRef",
            "StickerRef",
            "PosterStickerRef",
            "RunningSkinRef",
            "EmojiPackRef",
         ];
         this.$refs[arr[this.formData.businessType - 1]].submit(release);
      },
   },
}
</script>

<style scoped></style>


// WEBPACK FOOTER //
// PersonalizedPartDetail.vue?4ba160eb